export default "__VITE_ASSET__Cvrfpkph__"